import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '~/Containers/Global/Modal/Modal';
import { CONFIRM_DISCONNECT_CALENDAR_ACCOUNT_MODAL } from '~/Config/Modals';
import { closeModal } from '~/Redux/Modules/Modal';

import './ConfirmDisconnectAccount.scss';
import Button from '../Global/Form/Button';

const MainLogo = require('~/Components/Layout/ApplicationNavigation/MainLogo.png');

const ConfirmDisconnectAccount = ({ modalId }) => {
  const dispatch = useDispatch();
  const { modalData } = useSelector(({ Modal }) => Modal);

  const handleClose = result => {
    dispatch(closeModal(modalId));
    if (result) {
      modalData.confirmPromise?.resolve();
    } else {
      modalData.confirmPromise?.reject();
    }
  };

  const capitalize = string => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <Modal
      overlayClassName="confirm-disconnect-modal"
      id={modalId}
      ariaHideApp={false}
      onClose={() => modalData.confirmPromise?.reject()}
    >
      <div className="logo-wrapper">
        <img className="logo" src={MainLogo} alt="" />
      </div>

      <h1>Are you sure?</h1>
      <p>
        Disconnecting this calendar account will remove any custom colors or alarms set in Artful
        Agenda. Your events will, however, remain in your {capitalize(modalData?.accountType)}{' '}
        Calendar account.
      </p>
      <div className="actions">
        <Button text="NO" onClick={() => handleClose(false)} />
        <Button text="YES" onClick={() => handleClose(true)} />
      </div>
    </Modal>
  );
};

ConfirmDisconnectAccount.propTypes = {
  modalId: PropTypes.string,
};

ConfirmDisconnectAccount.defaultProps = {
  modalId: CONFIRM_DISCONNECT_CALENDAR_ACCOUNT_MODAL,
};

export default ConfirmDisconnectAccount;
